import {
  useCallback,
  useLayoutEffect,
  useState
} from 'react'

function getDimensionObject(node) {
  const rect = node.getBoundingClientRect()

  return {
    width: rect.width,
    height: rect.height,
    top: 'x' in rect ? rect.x : rect.top,
    left: 'y' in rect ? rect.y : rect.left,
    x: 'x' in rect ? rect.x : rect.left,
    y: 'y' in rect ? rect.y : rect.top,
    right: rect.right,
    bottom: rect.bottom
  }
}

export const useDimensions = () => {
  const [dimensions, setDimensions] = useState({})
  const [node, setNode] = useState(null)

  const ref = node => {
    if(node != null) {
      setNode(node)
    }
  }

  const measure = useCallback(() => {
    window.requestAnimationFrame(() => {
      setDimensions(getDimensionObject(node))
    })
  }, [node])

  useLayoutEffect(() => {
    if (node) {
      measure()

      window.addEventListener('resize', measure)
      window.addEventListener('scroll', measure)

      return () => {
        window.removeEventListener('resize', measure)
        window.removeEventListener('scroll', measure)
      }
    }
  }, [node, measure, node?.children])

  return [ref, dimensions, measure, node]
}
